<template>
  <div class="recommend-cart-list">
    <van-checkbox-group v-model="checked" :max="120" ref="drugCheck" @change="handleChange">
      <div v-for="(item, key) in orderList" :key="item.itemId + key" :class="'scrollView' + item.itemId">
        <van-swipe-cell>
          <div class="flex">
            <van-checkbox
              v-if="!expire"
              :disabled="!!(!item.stockNum || item.status)"
              :name="item.itemId"
              @click="handleClick(item.itemId, item, 120)"
              class="check-request flex center"
            ></van-checkbox>
            <div :class="!expire ? 'product-item-re' : 'product-item-re product-item-re-null'">
              <product-item :item="item" @handleDelete="handleDelete" :expire="expire"></product-item>
            </div>
          </div>

          <!-- <template #right>
            <van-button square text="删除" type="danger" @click="del(item)" class="delete-button" />
          </template> -->
        </van-swipe-cell>
      </div>
    </van-checkbox-group>
  </div>
</template>
<script>
import ProductItem from './productItem';

export default {
  components: { ProductItem },
  props: ['orderList', 'expire'],
  data() {
    return {
      checked: []
    };
  },
  mounted() {},
  methods: {
    toggleAll(checkedAll) {
      this.checked = [];
      if (checkedAll) {
        this.orderList.map(item => {
          if (item.stockNum && !item.status) {
            this.checked.push(item.itemId);
          }
        });
      }
    },

    handleChange(val) {
      this.$emit('input', val);
    },
    scrollIntoView(id) {
      document.querySelector('.scrollView' + id).scrollIntoView({
        behavior: 'smooth'
      });
    },
    handleDelete(itemId) {
      const inde = this.orderList.findIndex(item => item.itemId === itemId);
      if (inde !== -1) this.orderList.splice(inde, 1);
    },
    handleClick(id, item, num) {
      if (this.checked.length === num && this.checked.indexOf(id) === -1) {
        this.$toast(`单次最多提交${num}种`);
      }
    },
    del(item) {
      const { itemId, isDrug } = item;
      this.$dialog
        .confirm({
          title: '确认删除？',

          confirmButtonText: '再想想',
          cancelButtonText: '删除'
        })
        .then(() => {})
        .catch(() => {
          this.handleDelete(itemId);
        });
    }
  }
};
</script>
<style lang="less" scoped>
.recommend-cart-list {
  background: #fff;
  .check-request {
    min-width: 10.6%;
    position: relative;
    height: 104px;
    top: 0px;
    left: 2%;
    ::v-deep .van-checkbox__icon--checked {
      .van-icon {
        position: relative;
        &::before {
          position: absolute;
          // font-size: 12px;
          top: 2px;
          left: 1px;
        }
      }
    }
  }
  .product-item-re {
    width: 89.4%;
    &.product-item-re-null {
      width: 100%
    }
  }
  .delete-button {
    width: 60px;
    font-size: 16px;
    padding: 0;
    background: #e63d3d;
    height: 100%;
  }
}
</style>
